import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import CustomButton from '../../CustomButton';

const ReportBreadcrumbBar = ({ crumbs, onBack, backLabel }) => {
    const { t } = useTranslation('translation', { keyPrefix: 'components.reports' });

    const items = crumbs
        .map(item => (typeof item === 'string' ? { label: item } : item))
        .filter(item => item && item.label);

    return (
        <div className="page-subheader report-breadcrumb-bar">
            <nav>
                <ol className="report-breadcrumb">
                    {items.map((item, index) => {
                        const isCurrent = index === items.length - 1;
                        return (
                            <li key={`${index}-${item.label}`} className={`report-breadcrumb-item${isCurrent ? ' current' : ''}`}>
                                {!isCurrent && item.onClick
                                    ? <button type="button" className="report-breadcrumb-link" onClick={item.onClick}>{item.label}</button>
                                    : <span aria-current={isCurrent ? 'page' : undefined}>{item.label}</span>
                                }
                            </li>
                        );
                    })}
                </ol>
            </nav>
            {onBack &&
                <CustomButton
                    variant="secondary-outline"
                    prefix="report-back-btn"
                    onClick={onBack}
                >
                    {backLabel}
                </CustomButton>
            }
        </div>
    );
};

ReportBreadcrumbBar.propTypes = {
    crumbs: PropTypes.arrayOf(PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.shape({
            label: PropTypes.string,
            onClick: PropTypes.func
        })
    ])).isRequired,
    onBack: PropTypes.func,
    backLabel: PropTypes.string
};

export default ReportBreadcrumbBar;
